"use strict"

import React from "react"
import { Button, Form, Modal } from "react-bootstrap"
import { Formik } from "formik"
import * as Yup from "yup"

import { FormattedMessage } from "react-intl"
import { updateObject } from "../../../Loaders"
import { logToServer } from "../../../ErrorBoundary"
import UserInputField from "./UserInputField"

export const PasswordModal = ({ user, show, onHide, intl, getUsers, triggerAlert }) => {
  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required(intl.formatMessage({ id: "general.warning.requiredFormField" }))
      .min(8, intl.formatMessage({ id: "administration-user-management.password.minimum" })),
    confirmPassword: Yup.string()
      .required(intl.formatMessage({ id: "general.warning.requiredFormField" }))
      .oneOf(
        [Yup.ref("password")],
        intl.formatMessage({ id: "administration.user-management.confirmPassword.match" }),
      ),
  })

  const submitForm = (user, values) => {
    updateObject(`/users/list/${user.id}/change_password/`, values.password, true)
      .then((_) => {
        getUsers()
      })
      .catch((error) => {
        let errorMessage = "\n"
        console.error(error)
        logToServer(error)
        error
          .json()
          .then((data) => {
            console.error(data)
            logToServer(data)
            errorMessage = errorMessage + data.message
            triggerAlert("samplemanagement.error.unable.to.save.data", errorMessage)
          })
          .catch((err) => {
            console.error(err)
            logToServer(err)
            errorMessage = errorMessage + error.statusText
            triggerAlert("samplemanagement.error.unable.to.save.data", errorMessage)
          })
      })
  }

  return (
    <Modal
      user={user}
      show={show}
      onHide={onHide}
      backdrop={"static"}
      keyboard={false}
      style={{ overflowX: "scroll", overflowY: "scroll" }}
    >
      <Formik
        initialValues={{ password: "", confirmPassword: "" }}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true)
          setTimeout(() => {
            submitForm(user, values)
            resetForm()
            setSubmitting(false)
            onHide()
          }, 500)
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, isValid }) => (
          <Form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>
                <FormattedMessage
                  id={"administration.user-management.change-password"}
                  description={"Change Password"}
                />
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {/*---------- Password Field ----------*/}
              <UserInputField
                intl={intl}
                values={values}
                controlName={"password"}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
                type={"password"}
                show_complexity_help={true}
              />

              {/*---------- Validate Password Field ----------*/}
              <UserInputField
                intl={intl}
                values={values}
                controlName={"confirmPassword"}
                handleChange={handleChange}
                handleBlur={handleBlur}
                touched={touched}
                errors={errors}
                type={"password"}
                show_complexity_help={true}
              />
            </Modal.Body>

            <Modal.Footer>
              <Button variant={"outline-primary"} onClick={onHide}>
                <FormattedMessage id={"general.cancelButton"} description={"Cancel"} />
              </Button>
              <Button variant={"primary"} type={"submit"} disabled={!isValid}>
                <FormattedMessage id={"general.save"} description={"Submit changes"} />
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}
